<div class="mass-os-it-sync">
  <table
    mat-table
    multiTemplateDataRows
    [dataSource]="state.serviceStates"
    class="mass-os-it-sync__table"
  >
    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th mass-os-it-sync__th--expand"></th>
      <td mat-cell *matCellDef="let svc" class="mass-os-it-sync__td mass-os-it-sync__td--expand">
        <button
          *ngIf="hasTickets(svc)"
          type="button"
          mat-icon-button
          class="mass-os-it-sync__chevron"
          [attr.aria-expanded]="isExpanded(svc)"
          [attr.aria-label]="(isExpanded(svc) ? 'Contraer ' : 'Expandir ') + svc.nombreServicio"
          (click)="toggle(svc)"
        >
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="serviceDay">
      <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th">{{ headers.serviceDay }}</th>
      <td mat-cell *matCellDef="let svc" class="mass-os-it-sync__td">
        <span class="mass-os-it-sync__day">{{ svc.serviceDay }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="fecha">
      <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th">{{ headers.fecha }}</th>
      <td mat-cell *matCellDef="let svc" class="mass-os-it-sync__td">
        {{ formatShortDate(svc.fecha) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="tipoServicio">
      <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th">{{ headers.tipoServicio }}</th>
      <td mat-cell *matCellDef="let svc" class="mass-os-it-sync__td mass-os-it-sync__tipo">
        <i-tabler [name]="tipoIcon(svc.tipoServicio)" class="mass-os-it-sync__tipo-icon"></i-tabler>
        <span>{{ svc.tipoServicio }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="nombreServicio">
      <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th mass-os-it-sync__th--activity">{{ headers.nombreServicio }}</th>
      <td mat-cell *matCellDef="let svc" class="mass-os-it-sync__td mass-os-it-sync__td--activity">
        {{ svc.nombreServicio }}
      </td>
    </ng-container>

    <ng-container matColumnDef="nombre">
      <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th">{{ headers.nombre }}</th>
      <td mat-cell *matCellDef="let svc" class="mass-os-it-sync__td">{{ svc.nombre }}</td>
    </ng-container>

    <ng-container matColumnDef="moneda">
      <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th">{{ headers.moneda }}</th>
      <td mat-cell *matCellDef="let svc" class="mass-os-it-sync__td">{{ svc.moneda }}</td>
    </ng-container>

    <ng-container matColumnDef="pax">
      <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th">{{ headers.pax }}</th>
      <td mat-cell *matCellDef="let svc" class="mass-os-it-sync__td mass-os-it-sync__td--right">{{ svc.pax }}</td>
    </ng-container>

    <ng-container matColumnDef="costo">
      <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th mass-os-it-sync__th--right">{{ headers.costo }}</th>
      <td mat-cell *matCellDef="let svc" class="mass-os-it-sync__td mass-os-it-sync__td--right">
        {{ svc.costo | formatNumber }}
      </td>
    </ng-container>

    <!-- ── Campos inline para servicios NO-ticket (paso 0: fechas) ── -->
    <ng-container matColumnDef="fechaAutomatica">
      <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th">{{ headers.fechaAutomatica }}</th>
      <td mat-cell *matCellDef="let svc" class="mass-os-it-sync__td">
        <span *ngIf="!hasTickets(svc)">{{ formatShortDate(svc.fechaAutomatica) }}</span>
        <mat-icon
          *ngIf="hasTickets(svc)"
          class="mass-os-it-sync__locked"
          matTooltip="Se gestiona en el detalle de tickets"
          matTooltipPosition="above"
        >lock</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="fechaManual">
      <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th">{{ headers.fechaManual }}</th>
      <td mat-cell *matCellDef="let svc" class="mass-os-it-sync__td mass-os-it-sync__td--editable">
        <div *ngIf="!hasTickets(svc)" class="mass-os-it-sync__date-inline">
          <input
            class="mass-os-it-sync__date-input"
            [matDatepicker]="svcPicker"
            [value]="svc.fechaManual"
            (dateChange)="onDateChange(svc.serviceId, $event.value)"
            placeholder="dd/mm/aaaa"
            readonly
          />
          <mat-icon
            class="mass-os-it-sync__date-icon"
            (click)="svcPicker.open()"
          >event</mat-icon>
          <mat-datepicker #svcPicker panelClass="sync-datepicker-panel"></mat-datepicker>
        </div>
        <mat-icon
          *ngIf="hasTickets(svc)"
          class="mass-os-it-sync__locked"
          matTooltip="Se gestiona en el detalle de tickets"
          matTooltipPosition="above"
        >lock</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="fechaFinal">
      <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th">{{ headers.fechaFinal }}</th>
      <td mat-cell *matCellDef="let svc" class="mass-os-it-sync__td">
        <span *ngIf="!hasTickets(svc)" class="mass-os-it-sync__td--bold">{{ formatShortDate(getFinalDate(svc)) }}</span>
        <mat-icon
          *ngIf="hasTickets(svc)"
          class="mass-os-it-sync__locked"
          matTooltip="Se gestiona en el detalle de tickets"
          matTooltipPosition="above"
        >lock</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th">{{ headers.status }}</th>
      <td mat-cell *matCellDef="let svc" class="mass-os-it-sync__td">
        <span *ngIf="!hasTickets(svc)" class="mass-os-it-sync__chip" [ngClass]="getStatusClass(svc.status)">
          {{ getStatusLabel(svc.status) }}
        </span>
        <mat-icon
          *ngIf="hasTickets(svc)"
          class="mass-os-it-sync__locked"
          matTooltip="Se gestiona en el detalle de tickets"
          matTooltipPosition="above"
        >lock</mat-icon>
      </td>
    </ng-container>

    <!-- ── Campos inline para servicios NO-ticket (paso 1: código reserva) ── -->
    <ng-container matColumnDef="codigoReserva">
      <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th">{{ headers.codigoReserva }}</th>
      <td mat-cell *matCellDef="let svc" class="mass-os-it-sync__td mass-os-it-sync__td--editable">
        <input
          *ngIf="!hasTickets(svc)"
          type="text"
          class="mass-os-it-sync__code-input"
          placeholder="Opcional"
          [value]="svc.codigoReserva ?? ''"
          (input)="onCodeChange(svc.serviceId, $any($event.target).value)"
        />
        <mat-icon
          *ngIf="hasTickets(svc)"
          class="mass-os-it-sync__locked"
          matTooltip="Se gestiona en el detalle de tickets"
          matTooltipPosition="above"
        >lock</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td
        mat-cell
        *matCellDef="let svc"
        [attr.colspan]="displayedColumns.length"
        class="mass-os-it-sync__detail-cell"
        [ngClass]="{
          'mass-os-it-sync__detail-cell--open': isExpanded(svc)
        }"
      >
        <div class="mass-os-it-sync__detail">
          <!-- ── Servicio TICKET: sub-tabla de tickets ── -->
          <ng-container *ngIf="hasTickets(svc)">
            <table
              mat-table
              [dataSource]="svc.tickets!"
              class="mass-os-it-sync__tickets-table"
            >
              <ng-container matColumnDef="ticketId">
                <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th">TICKET</th>
                <td mat-cell *matCellDef="let t" class="mass-os-it-sync__td">
                  <span class="mass-os-it-sync__ticket-badge">Ticket {{ t.ticketId }}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="moneda">
                <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th">MONEDA</th>
                <td mat-cell *matCellDef="let t" class="mass-os-it-sync__td">{{ t.moneda }}</td>
              </ng-container>

              <ng-container matColumnDef="total">
                <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th mass-os-it-sync__th--right">MONTO</th>
                <td mat-cell *matCellDef="let t" class="mass-os-it-sync__td mass-os-it-sync__td--right">
                  {{ t.total | formatNumber }}
                </td>
              </ng-container>

              <ng-container matColumnDef="fechaAutomatica">
                <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th">FECHA AUTO</th>
                <td mat-cell *matCellDef="let t" class="mass-os-it-sync__td">
                  {{ formatShortDate(t.fechaAutomatica) }}
                </td>
              </ng-container>

              <ng-container matColumnDef="fechaManual">
                <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th">NUEVA FECHA</th>
                <td mat-cell *matCellDef="let t" class="mass-os-it-sync__td mass-os-it-sync__td--editable">
                  <div class="mass-os-it-sync__date-inline">
                    <input
                      class="mass-os-it-sync__date-input"
                      [matDatepicker]="ticketPicker"
                      [value]="t.fechaManual"
                      (dateChange)="onTicketDateChange(svc, t.ticketId, $event.value)"
                      placeholder="dd/mm/aaaa"
                      readonly
                    />
                    <mat-icon
                      class="mass-os-it-sync__date-icon"
                      (click)="ticketPicker.open()"
                    >event</mat-icon>
                    <mat-datepicker #ticketPicker panelClass="sync-datepicker-panel"></mat-datepicker>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="fechaFinal">
                <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th">FECHA PAGO FINAL</th>
                <td mat-cell *matCellDef="let t" class="mass-os-it-sync__td mass-os-it-sync__td--bold">
                  {{ formatShortDate(getTicketFinalDate(t)) }}
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th">ESTADO</th>
                <td mat-cell *matCellDef="let t" class="mass-os-it-sync__td">
                  <span class="mass-os-it-sync__chip" [ngClass]="getStatusClass(t.status)">
                    {{ getStatusLabel(t.status) }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="codigoReserva">
                <th mat-header-cell *matHeaderCellDef class="mass-os-it-sync__th">CÓDIGO RESERVA</th>
                <td mat-cell *matCellDef="let t" class="mass-os-it-sync__td mass-os-it-sync__td--editable">
                  <input
                    type="text"
                    class="mass-os-it-sync__code-input"
                    placeholder="Opcional"
                    [value]="t.codigoReserva ?? ''"
                    (input)="onTicketCodeChange(svc, t.ticketId, $any($event.target).value)"
                  />
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="ticketDisplayedColumns" class="mass-os-it-sync__tickets-header"></tr>
              <tr
                mat-row
                *matRowDef="let t; columns: ticketDisplayedColumns;"
                class="mass-os-it-sync__tickets-row"
              ></tr>
            </table>
          </ng-container>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="mass-os-it-sync__header-row"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns;"
      class="mass-os-it-sync__row"
      [class.mass-os-it-sync__row--expanded]="isExpanded(row)"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: ['expandedDetail']; when: isTicketRow;"
      class="mass-os-it-sync__detail-row"
    ></tr>
  </table>
</div>
